<h2>{{ 'Create New Team' | platformLabel }}</h2>
<app-team-add-details></app-team-add-details>
<mat-dialog-actions>
  <div>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!teamDetails.isValid || saving"
      (click)="save()"
      id="create-team-button"
    >
      Create
    </button>
    <button
      type="button"
      mat-button
      (click)="dialogRef.close()"
      id="cancel-team-button"
    >
      Cancel
    </button>
  </div>
</mat-dialog-actions>
